export interface ShippingBoxStandardType {
	width_mm: number
	height_mm: number
	depth_mm: number
}

export interface ShinngBoxStandardObjType {
	a: ShippingBoxStandardType
	b: ShippingBoxStandardType
	c: ShippingBoxStandardType
	d: ShippingBoxStandardType
	e: ShippingBoxStandardType
}

export interface ShippingBoxSizeType {
	boxType: 'A' | 'B' | 'C' | 'D' | 'E'
	weight_kg: number
	width_cm: number
	height_cm: number
	depth_cm: number
}

const boxStandards: ShinngBoxStandardObjType = {
	a: {
		width_mm: 360,
		height_mm: 240,
		depth_mm: 120,
	},
	b: {
		width_mm: 320,
		height_mm: 320,
		depth_mm: 220,
	},
	c: {
		width_mm: 450,
		height_mm: 275,
		depth_mm: 275,
	},
	d: {
		width_mm: 450,
		height_mm: 350,
		depth_mm: 270,
	},
	e: {
		width_mm: 500,
		height_mm: 400,
		depth_mm: 300,
	},
}

export const ShippingBox = {
	getSize: ({
		kdm6Qty,
		kdm4Qty,
	}: {
		kdm6Qty: number
		kdm4Qty: number
	}): ShippingBoxSizeType => {
		const sumQty = kdm6Qty + kdm4Qty
		const unitKdm6Weight_g = 1200
		const unitKdm4Weight_g = 900
		const weight_g: number = unitKdm6Weight_g * kdm6Qty + unitKdm4Weight_g * kdm4Qty
		const weight_kg = Number((weight_g / 1000).toFixed(1))

		const boxType: 'a' | 'b' | 'c' | 'd' | 'e' = [1, 2].includes(sumQty)
			? 'a'
			: [3, 4].includes(sumQty)
			? 'b'
			: [5, 6].includes(sumQty)
			? 'c'
			: [7, 8].includes(sumQty)
			? 'd'
			: sumQty > 10
			? 'e'
			: 'e'

		const boxSize: ShippingBoxStandardType = boxStandards[boxType]

		const res: ShippingBoxSizeType = {
			boxType: boxType.toUpperCase() as 'A' | 'B' | 'C' | 'D' | 'E',
			weight_kg: weight_kg,
			width_cm: Number((boxSize.width_mm / 10).toFixed(2)),
			height_cm: Number((boxSize.height_mm / 10).toFixed(2)),
			depth_cm: Number((boxSize.depth_mm / 10).toFixed(2)),
		}

		return res
	},
}

/**
박스
A: 360 x 240 x 120
B: 320 x 320 x 220
C: 450 x 275 x 275
D: 450 x 350 x 270
E: 500 x 400 x 300

qty
1: 200x130x70 (220x150x90) A
2: 260x200x70 (300x220x90) A
3: 260x200x140 (300x220x160 or 270x220x150) B
4: 260x200x140 (300x220x180 or 360x220x150) B
5: 260x200x210 (390x220x180 or 310x300x180) C
6: 260x200x210 (300x270x240) C
7: 260x200x210 (370x270x220 or 310x280x270) D
8: 260x200x210 (360x280x220) D
9: 260x200x210 (370x360x220 or 360x280x220) E
10: 260x200x210 (450x280x220 or 440x390x180) E
*/
